import { Controller } from 'stimulus';
import { useDebounce, useDispatch } from 'stimulus-use';

import { useAutoFocusable } from '../mixins';
import ElementListener from '../../lib/element_listener';

export default class extends Controller {
  submit = (ev) => {
    this.element.requestSubmit()
  }
}
